export default "__VITE_ASSET__BNo1Y$sH__"